import { formatNumber } from "@angular/common";

export const secondsToFormattedMinutes = (value: number): string => {
  const minutes = formatNumber(Math.floor(value / 60), "en", "2.0");
  const seconds = formatNumber(Math.floor(value % 60), "en", "2.0");

  return `${minutes}:${seconds}`;
};
